showLoginModal = function () {
    $("body").toggleClass("body-modal-login");
    $(".backdrop-login, .modal-login .modal-inner").fadeToggle();
};

//For the modal links of login / cart and right click open in new tab functionality
window.onload = function () {
    var loginBtn = document.getElementById("loginbtn");
    if (loginBtn) {
        loginBtn.onclick = function () {
            return false;
        };
    }
    var cartBtn = document.getElementById("cartbtn");
    if (cartBtn) {
        cartBtn.onclick = function () {
            return false;
        };
    }

    shareButton = function shareButton(title = '', url = '', text = '') {
        let shareData = {
            title: title,
            text: text,
            url: url
        }

        try {
            navigator.share(shareData)
        } catch (err) {
        }
    }
};

$(document).ready(function () {
    $('.hidden-title').hover(function (e) {
        $(this).attr('title', "");
    });
});
